"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var blueimp_load_image_1 = __importDefault(require("blueimp-load-image"));
/**
 * Calculates the center of a [[RectCoords]].
 * @param rect The [[RectCoords]] to calculate the center coordinate from.
 */
function rectCenter(_a) {
    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2;
    return [
        ((x2 - x1) / 2 + x1),
        ((y2 - y1) / 2 + y1)
    ];
}
/**
 * Calculate distance between two points
 * @param x1 The x coordinate of the first point.
 * @param y1 The y coordinate of the first point.
 * @param x2 The x coordinate of the second point.
 * @param y2 The y coordinate of the second point.
 */
var dist2d = function (_a, _b) {
    var x1 = _a[0], y1 = _a[1];
    var x2 = _b[0], y2 = _b[1];
    return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
};
/**
 * Return first `Rect` from list `regions` with center-point which has a maximal distance of `maxDistance` from
 * the center. Otherwise return `defaultRect`
 * @param regions
 * @param maxDistance
 * @param defaultRect
 */
function selectFirstCenteredRegion(regions, maxDistance, defaultRect) {
    var centeredRegion = regions.filter(function (r) {
        var dist = dist2d([0.5, 0.5], rectCenter(r.normalizedRect));
        return dist < maxDistance;
    });
    if (centeredRegion.length === 0) {
        return defaultRect;
    }
    return centeredRegion[0].normalizedRect;
}
exports.selectFirstCenteredRegion = selectFirstCenteredRegion;
/**
 * Gets url parameter values by name.
 * @param name The parameter name.
 * @returns string value if it has value assigned with `=`, true if it is specified but without value or `undefined` if not present
 */
function getUrlParam(name) {
    var results = new RegExp("[?&]" + name + "(=([^&#]*))?(&|$|#)", 'i')
        .exec(window.location.href);
    if (results && results[2]) { // has value
        console.log('has value', name, results[2]);
        return decodeURIComponent(results[2]);
    }
    return (results && true) // present but without value
        || undefined; // not present
}
exports.getUrlParam = getUrlParam;
/**
 * Calculate the size of a thumbnail image while keeping proportions, based on pixel area.
 * This leads to better results in cases, where the aspect ratio is extreme.
 * @param targetWidth The desired width of the image.
 * @param targetHeight The desired height of the image.
 * @param aspectRatio Aspect ratio of the image.
 */
function getThumbSizeArea(targetWidth, targetHeight, aspectRatio) {
    var targetArea = targetWidth * targetHeight;
    var width = Math.sqrt(targetArea * aspectRatio);
    return {
        w: width,
        h: width / aspectRatio
    };
}
exports.getThumbSizeArea = getThumbSizeArea;
/**
 * Calculate the size of a thumbnail image to fit in `maxWith` and `maxHeight` while preserving the aspect ratio.
 * @param maxWidth
 * @param maxHeight
 * @param originalWidth
 * @param originalHeight
 */
function getThumbSizeLongestEdge(maxWidth, maxHeight, originalWidth, originalHeight) {
    var iR = originalWidth / originalHeight;
    var dR = maxWidth / maxHeight;
    if (dR > iR) {
        return {
            w: originalWidth * maxHeight / originalHeight,
            h: maxHeight
        };
    }
    return {
        w: maxWidth,
        h: originalHeight * maxWidth / originalWidth
    };
}
exports.getThumbSizeLongestEdge = getThumbSizeLongestEdge;
function scaleRect(r, size) {
    return {
        x1: r.x1 * size.w,
        x2: r.x2 * size.w,
        y1: r.y1 * size.h,
        y2: r.y2 * size.h
    };
}
exports.scaleRect = scaleRect;
/**
 * Calculates the size of a rect.
 * @param r The [[RectCoords]].
 */
function getRectSize(r) {
    return {
        w: r.x2 - r.x1,
        h: r.y2 - r.y1
    };
}
exports.getRectSize = getRectSize;
/**
 * Get aspect ratio of a rect
 * @param rect The normalized rect.
 * @param size The original image size.
 */
function getRectAspectRatio(rect, size) {
    var scaledRect = scaleRect(rect, size);
    var _a = getRectSize(scaledRect), w = _a.w, h = _a.h;
    return w / h;
}
exports.getRectAspectRatio = getRectAspectRatio;
function getElementSize(elem) {
    var img = elem;
    var video = elem;
    return {
        w: img.naturalWidth || video.videoWidth || elem.width,
        h: img.naturalHeight || video.videoHeight || elem.height
    };
}
exports.getElementSize = getElementSize;
function elementToCanvas(elem, newSize, normalizedRect) {
    var _a = getElementSize(elem), ow = _a.w, oh = _a.h;
    var _b = normalizedRect ? normalizedRect : {
        x1: 0,
        x2: 1,
        y1: 0,
        y2: 1
    }, x1 = _b.x1, x2 = _b.x2, y1 = _b.y1, y2 = _b.y2;
    var w = x2 - x1;
    var h = y2 - y1;
    // scale to absolute pixels
    var sx = ow * x1;
    var sw = ow * w;
    var sy = oh * y1;
    var sh = oh * h;
    var dw = (newSize && newSize.w) || ow;
    var dh = (newSize && newSize.h) || oh;
    var canvas = document.createElement('canvas');
    canvas.width = dw;
    canvas.height = dh;
    var context = canvas.getContext('2d');
    if (!context) {
        throw Error("Error converting element to canvas: Can not get 2d context");
    }
    // fill with white first to
    context.fillStyle = "rgb(255, 255,255)";
    context.fillRect(0, 0, dw, dh);
    context.drawImage(elem, sx, sy, sw, sh, 0, 0, // dx dy
    dw, dh);
    return canvas;
}
exports.elementToCanvas = elementToCanvas;
function urlOrBlobToCanvas(file) {
    return new Promise(function (resolve, reject) {
        // File can also be an image element
        blueimp_load_image_1.default(file, (function (data) {
            var c = data;
            if (c) {
                resolve(c);
            }
            else {
                reject();
            }
        }), {
            canvas: true,
            orientation: true,
            crossOrigin: 'anonymous'
        });
    });
}
exports.urlOrBlobToCanvas = urlOrBlobToCanvas;
function canvasToJpgBlob(canvas, quality) {
    return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
            if (blob) {
                resolve(blob);
            }
            else {
                reject();
            }
        }, 'image/jpeg', quality);
    });
}
exports.canvasToJpgBlob = canvasToJpgBlob;
exports.cadExtensions = ['.stp', '.step', '.stl', '.obj', '.glb', '.gltf'];
function isCadFile(file) {
    return exports.cadExtensions.some(function (ex) { return file.name.endsWith(ex); });
}
exports.isCadFile = isCadFile;
function isImageFile(file) {
    return file.type.startsWith('image/');
}
exports.isImageFile = isImageFile;
/**
 * Measures time remaining for a promise to resolve.
 * @param promise The promise
 */
function timePromise(promise) {
    return __awaiter(this, void 0, void 0, function () {
        var t1, res, t2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    t1 = Date.now();
                    return [4 /*yield*/, promise];
                case 1:
                    res = _a.sent();
                    t2 = Date.now();
                    return [2 /*return*/, { res: res, durationSeconds: (t2 - t1) / 1000 }];
            }
        });
    });
}
exports.timePromise = timePromise;
//# sourceMappingURL=utils.js.map